<template>
    <div class="poet-list-item">
        <!-- 头像 -->
        <div class="avatar">
            <img :src="poet.avatar">
        </div>

        <!-- 诗人信息 -->
        <div class="info">
            <!-- 姓名 -->
            <div class="poet-name" @click="$router.push('/poetDetail/'+poet.id)" v-html="poet.name"></div>
            <!-- 朝代 -->
            <div class="dynasty" v-html="poet.dynasty"></div>
            <!-- 简介 -->
            <div class="poet-intro" v-html="poet.intro"></div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "PoetListItem",
        props:['poet']
    }
</script>

<style scoped lang="less">
    .poet-list-item{
        background-color: white;
        width: 100%;
        margin-bottom: 25px;
        padding: 25px;
        box-sizing: border-box;
        background-image: url("../assets/texture.png");
        background-repeat: repeat;
        border-radius: 10px;
        box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
        display: flex;
        /* 头像 */
        .avatar{
            img{
                border-radius: 6px;
                display: block;
                width: 200px;
            }
        }

        /* 信息 */
        .info{
            margin-left: 15px;
            /* 诗人名称 */
            .poet-name{
                font-size: 19px;
                font-weight: bold;
                cursor: pointer;
                user-select: none;
                line-height: 22px;
            }
            /* 诗人朝代 */
            .dynasty{
                color: #303133;
                font-weight: bold;
                font-size: 15px;
                line-height: 18px;
                margin-top: 7px;
            }
            /* 简介 */
            .poet-intro{
                margin-top: 2px;
                color: #606266;
                font-size: 16px;
                line-height: 23px;
            }
            /* 诗人名称被hover */
            .poet-name:hover{
                color: #c04851;
            }
        }
    }
</style>